export default {
    'created-by-oms': 'Aangemaakt door OMS',
    'created-by-external-party': 'Aangemaakt door externe partij',
    'proposal-to-be-released-automatically': 'Zal automatisch verwerkt worden',
    'proposal': 'Te accorderen',
    'decision-denied-final': 'Geweigerd',
    'decision-approved-final': 'Goedgekeurd',
    'refund-to-be-processed': 'In de rij om te verwerken',
    'refund-processing': 'Uitbetaling aangevraagd',
    'refund-to-be-processed-manually': 'Handmatige uitbetaling',
    'refund-processing-manually': 'Handmatige uitbetaling (in behandeling)',
    'refund-error': 'Fout bij verwerking',
    'refunded': 'Verwerkt',
    'refunded-externally': 'Verwerkt buiten OMS',
}
